import React from 'react';
import { Badge } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const MobilePanel = ({ nbOffers, handlePanelNavigation }) => {

  const handlePanelClick = () => {
    if(nbOffers > 0) handlePanelNavigation();
  }

  return (
    <>
      <div className="shoppingLogo" onClick={() => handlePanelClick()}>
        <FontAwesomeIcon className="shoppingIcon" size="lg" icon="shopping-bag" />
        <Badge className="shoppingBadge">
          {nbOffers}
        </Badge>
      </div>
    </>
  )
}

export default MobilePanel
